import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';

import { Toast } from 'primereact/toast';
import { Companyid, DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';


class OutletMaster extends Component {
    state = {
        selectedItems: [],
        branchId: '',
        branchCode: '',
        branchName: ''
    }


    actionTemplate = (rowData) => {

        return <div className="actionCenter">
            {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
                <Link to={"/outlet/edit/" + rowData.branchId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess !== undefined && this.getAccess.viewAccess !== false) &&
                <Link to={"/outlet/view/" + rowData.branchId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
        </div>;
    }

    delete = () => {

        if (this.state.selectedItems.length > 0) {
            const updatedValue = this.state.selectedItems.map(value => {
                return { DeleteID: value.userId };
            })
            this.props.dynamicDeleteProcess('Branch', updatedValue, 'res/GetbranchList');
        }
        else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select checkbox' });
        }

    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if (rowData.isActive === true || rowData.isActive === null) {
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
            {status}
        </div>;
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        // this.props.getMasterTableList('res/GetbranchList?' + Companyid)  // Fetches branch data
        this.props.getMasterTableList('res/GetbranchList', Companyid)  // Note: 'branch' instead of 'branc'

        // Get the type and id from URL params
        let type = this.props.match.params.type;  // 'add', 'edit', or 'view'
        let id = this.props.match.params.id;

        console.log('Component mounted with type:', type, 'id:', id);

        // // Set the mode
        // if (type === 'add') {
        //     this.setState({
        //         type: 'add',
        //         mode: 'add',
        //         isViewMode: false,
        //         isEditMode: false
        //     });
        // } else if (type === 'edit') {
        //     this.setState({
        //         type: 'edit',
        //         mode: 'edit',
        //         isViewMode: false,
        //         isEditMode: true
        //     });
        //     // Fetch data for editing
        //     this.fetchOutletData(id);
        // } else if (type === 'view') {
        //     this.setState({
        //         type: 'view',
        //         mode: 'view',
        //         isViewMode: true,
        //         isEditMode: false
        //     });
        //     // Fetch data for viewing
        //     this.fetchOutletData(id);
        // }

        // if (id !== "new") {
        //     this.props.getOutletById(id);
        // }
        // this.setState({
        //     isEditMode: type === "edit",
        //     isViewMode: type === "view"
        // });

    }

    componentDidUpdate(prevProps) {
        if (
            this.props.outletData &&
            this.props.outletData !== prevProps.outletData
        ) {
            this.setState({
                branchId: this.props.outletData.branchId,
                branchCode: this.props.outletData.branchCode,
                branchName: this.props.outletData.branchName
            });
        }
    }

    // change = (e) => {
    //     // If in view mode, don't allow changes
    //     if (this.state.isViewMode) {
    //         return;
    //     }
    // }


    // componentDidUpdate() {
    //     console.log("Selected Items:", this.state.selectedItems)
    // }

    render() {

        if (this.getAccess !== undefined && this.getAccess.viewAccess === false) {
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{ 'textAlign': 'right' }}>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );

        let tableData = [];

        // if (this.props.tableLists.usersList !== undefined) {
        //     tableData = this.props.tableLists.usersList;  // This actually contains branch data
        // }


        // Change the data source name
        if (this.props.tableLists !== undefined) {
            tableData = this.props.tableLists;
        }


        return (
            <div className="p-grid padding">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Outlet</h1>

                        <div className="p-grid">


                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                    {(this.getAccess !== undefined && this.getAccess.addAccess !== false) &&
                                        <Link to="/outlet/add/new"><Button style={{ float: 'right' }} label="Add Outlet" className="ml1" icon="pi pi-plus" /></Link>
                                    }
                                    {(this.getAccess !== undefined && this.getAccess.deleteAccess !== false) &&
                                        <Button style={{ float: 'right' }} onClick={this.delete} label="Delete" icon="pi pi-trash" className="p-button-danger" />
                                    }

                                </div>
                            </div>


                            <div className="p-col-12" style={{ marginTop: '2em' }}>

                                <DataTable value={tableData}
                                    selection={this.state.selectedItems} onSelectionChange={e => this.setState({ selectedItems: e.value })}
                                    globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    {/* <Column field="userid1" header="Restaurant/Kitchen" sortable={true} />
                                    <Column field="firstName" header="Type" />
                                    <Column field="lastName" header="State" />
                                    <Column field="mobileNumber" header="City" />
                                    <Column field="lastName" header="Outlet Type" /> */}
                                    {/* <Column field="isActive" header="STATUS" body={this.statusRender} sortable={true} /> */}

                                    {/* <Column field="branchId" header="Branch ID" /> */}
                                    <Column field="branchCode" header="Branch Code" />
                                    <Column field="branchName" header="Branch Name" />
                                    <Column field="action" body={this.actionTemplate} header="Action" />
                                </DataTable>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dynamicDeleteProcess: (model, data, func) => dispatch(actions.dynamicDeleteProcess(model, data, func)),
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OutletMaster);